import { motion } from 'framer-motion';

const EASE = [0.76, 0, 0.24, 1];

export function MaskReveal({ children, delay = 0, className = '', immediate = false }) {
  const triggerProps = immediate
    ? { initial: { y: '110%' }, animate: { y: 0 } }
    : { initial: { y: '110%' }, whileInView: { y: 0 }, viewport: { once: true, margin: '-10%' } };
  return (
    <span className={`mask-reveal ${className}`}>
      <motion.span
        {...triggerProps}
        transition={{ duration: 0.9, ease: EASE, delay }}
        className="inline-block will-change-transform"
      >
        {children}
      </motion.span>
    </span>
  );
}

export function MaskLines({ lines, className = '', lineClassName = '', immediate = false, baseDelay = 0.1 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => {
        const triggerProps = immediate
          ? { initial: { y: '110%' }, animate: { y: 0 } }
          : { initial: { y: '110%' }, whileInView: { y: 0 }, viewport: { once: true, margin: '-10%' } };
        return (
          <span key={i} className="block mask-reveal">
            <motion.span
              {...triggerProps}
              transition={{ duration: 1.0, ease: EASE, delay: baseDelay + i * 0.12 }}
              className={`inline-block will-change-transform ${lineClassName}`}
            >
              {line}
            </motion.span>
          </span>
        );
      })}
    </span>
  );
}

export function FadeUp({ children, delay = 0, className = '', y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
